<template>
  <div>
    <v-layout wrap justify-right class="mt-3 mb-3">
      <v-flex xs12 sm8></v-flex>
      <v-flex xs12 sm4>
        <div class="form-control">
          <input type="text" name id :placeholder="$t('Search')" v-model="search" />
        </div>
      </v-flex>
    </v-layout>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="customers"
      class="elevation-1"
      :search="search"
      item-key="name"
      :rows-per-page-items="[25, 35, 50, { text: $t('All'), value: -1 }]"
      :pagination.sync="pagination"
      :rows-per-page-text="$t('Rows per page')"
    >
      <template slot="no-data">
        <div class="text-xs-center">{{ $t('No customer') }}</div>
      </template>
      <template v-slot:items="props">
        <customer :item="props.item"></customer>
      </template>
    </v-data-table>
    <div style="min-height: 90px"></div>
  </div>
</template>

<script>
import api from '@/api'
import Customer from './Customer'
import moment from 'moment'
export default {
  data() {
    return {
      search: '',
      loading: true,
      pagination: {
        sortBy: 'timegap',
        descending: true,
        rowsPerPage: 25
      },
      headers: [
        { text: 'ชื่อ', value: 'first_name' },
        { text: 'ช่องทาง', value: 'app', align: 'center' },
        { text: 'หัวเรื่อง', value: 'subject' },
        { text: 'Tag', value: 'answer_count', sortable: false },
        { text: 'เวลาเริ่มบทสนทนา', value: 'starttime' },
        { text: 'เวลาที่ลูกค้ารอ', value: 'timegap' },
        { text: 'ผู้รับงาน', value: 'assign_by_first_name' }
        // { text: '', width: '1%' }
      ],
      customers: [],
      fetchInterval: undefined
    }
  },
  components: {
    Customer
  },
  mounted() {
    var vm = this
    vm.loading = true
    vm.getOpenTasks().then((data) => {
      vm.customers = data
      vm.loading = false
    })
    vm.fetchInterval = setInterval(() => {
      vm.loading = true
      vm.getOpenTasks().then((data) => {
        vm.customers = data
        vm.loading = false
      })
    }, 10000)
  },
  methods: {
    getOpenTasks() {
      return new Promise((resolve, reject) => {
        api.getOpentasks(null, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            var customers = []
            let now = moment()
            response.data.map((customer) => {
              let c = customer
              let updatetime = moment(c.updatetime)
              if (c.adminupdatetime != null) {
                let adminupdatetime = moment(c.adminupdatetime)

                if (adminupdatetime.diff(updatetime) >= 0) {
                  c.timegap = 0
                } else {
                  c.timegap = now.diff(updatetime, 'seconds')
                }
              } else {
                c.timegap = now.diff(updatetime, 'seconds')
              }
              customers.push(c)
            })

            resolve(customers)
          }
        })
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.fetchInterval)
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/qualityexpress/Customers.vue